
import {
  Component, Watch, Mixins,
} from 'vue-property-decorator';
import ProgressBar from '@/features/shipment/components/ProgressBar.vue';
import { getInProgressData } from '@/features/shipment/services/shipment.services';
import { getUserNotificationsPrefs } from '@/features/settings/services/notifications.services';
import { fetchAndCommitIntegrationConnectedData } from '@/features/ecommerce/helpers/eCommerce';
import WhiteLabelMixin from '@/features/common/mixins/whiteLabelMixin';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { UserPreferences } from '@/features/settings/types';
import { InProgress } from '../types';
import { setDefaultInprogressData } from '../helpers/createShipment';
import { pageWithoutShipmentProgress } from '../constants';

@Component({
  components: {
    ProgressBar,
  },
})
export default class Shipment extends Mixins(WhiteLabelMixin) {
  get showProgressBar(): boolean {
    return !pageWithoutShipmentProgress.includes(this.$route.name || '');
  }

  get isInitialDataLoaded(): number {
    return this.$store.getters.getIsInitialDataLoaded;
  }

  get inProgressData(): InProgress {
    return this.$store.getters.getInProgress;
  }

  get userPreferences(): UserPreferences {
    return this.$store.getters.getUserPreferences;
  }

  // eslint-disable-next-line class-methods-use-this
  destroyed(): void {
    eventBus.$off(eventNames.SHIPMENT_SUBMIT);
  }

  @Watch('inProgressData', { deep: true })
  private onInProgressChange() {
    this.$store.commit('setChangeInProgressData', true);
  }

  @Watch('isInitialDataLoaded', { immediate: true })
  private loadAndStoreInProgressData(newValue: number) {
    if (!newValue) return;

    this.fetchAndCommitInProgressData();
    fetchAndCommitIntegrationConnectedData();
    this.fetchAndCommitUserNotifications();
  }

  private async fetchAndCommitInProgressData() {
    const inProgressData = await getInProgressData();

    if (inProgressData) {
      this.$store.commit('setInProgress', inProgressData);
      return;
    }

    setDefaultInprogressData();
  }

  private async fetchAndCommitUserNotifications() {
    const notificationPrefs = await getUserNotificationsPrefs();
    this.$store.commit('setNotificationPrefs', notificationPrefs);
  }
}
